import React, { useState, useEffect } from "react";
import aboutImage from "@assets/images/about-us/otomol-banner.jpg";
import Header from "@pages/private/Layout/Header";
import Footer from "@pages/private/Layout/Footer";

const AboutUs = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const updateImage = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
    };

    updateImage(); // Set initial image
    window.addEventListener("resize", updateImage);

    return () => {
      window.removeEventListener("resize", updateImage);
    };
  }, []);

  return (
    <React.Fragment>
      <Header />
      <div className="min-h-screen bg-white">
        {/* Main Content */}
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl -mt-4 sm:-mt-8 mb-4">
          <div className="row">
            <div className="col-12">
              <h1 className="text-2xl font-bold m-0 pt-8 pb-4">Hakkımızda</h1>
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="relative w-full max-w-4xl mx-auto group">
              <img
                src={aboutImage}
                alt="Hakkımızda"
                loading="lazy"
                className="w-full h-[500px] object-cover object-center rounded-2xl shadow-2xl"
              />

              <div className="mt-3">
                <h4>1916 yılından beri Türkiye’nin yağı Turyağ</h4>

                <p>
                  1916 yılında İzmir’de kurulan küçük bir yağhanenin devamı olan
                  Turyağ, 1920’li yıllarda bitkisel margarine yaptığı yatırımlar
                  sonucu 1932 yılında ilk bitkisel margarinini piyasaya sürdü.
                  1930’lu yılların sonlarında yılda yaklaşık 500 ton zeytinyağı
                  ve 2.500 ton küspe ihracatı yapan Turyağ, 1996 yılında
                  merkezini İstanbul’a taşıdı. 2008 yılında ise üretim tesisini
                  Turan, İzmir’den Balıkesir’deki modern tesislere taşıdı.
                </p>

                <p>
                  Turyağ, kalitesinden ve lezzetinden ödün vermeyerek, yenilikçi
                  kimliğiyle gıda endüstrisinin ve pastacılık ustalarının
                  vazgeçilmezi olmaya devam etmektedir. Ev Dışı Tüketim pazarına
                  hitap eden birçok ürünü sunan Turyağ, profesyonel mutfaklar
                  için geniş bir kullanım alanı sağlamaktadır. Türkiye’nin önde
                  gelen yağ üreticilerinden biri olan Turyağ’ın endüstriyel ve
                  sıvı yağ markaları, entegre tesisleri ve başarılı
                  organizasyonu ile birlikte 2014 yılında global gıda şirketi
                  Cargill bünyesine katıldı.
                </p>
              </div>

              <div className="mt-3">
                <h4>Dünyada Cargill</h4>

                <p>
                  Cargill; gıda, tarım, finans ve endüstriyel ürün sektörlerinde
                  faaliyet gösteren küresel bir şirkettir. Çiftçiler,
                  müşteriler, yerel yönetimler ve toplumlar ile birlikte,
                  bilgimizi ve 155 yıllık deneyimimizi paylaşıyor, herkesin daha
                  başarılı olmasına katkıda bulunuyoruz. 70 ülkede, yaşadığımız
                  ve çalıştığımız her yerde, kendisini; dünyanın sorumlu bir
                  şekilde beslenmesine, çevresel etkiyi en aza indirmeye ve
                  topluluklara değer katmaya adamış 155.000’in üzerinde
                  çalışanımız ile gurur duyuyoruz.
                </p>
              </div>

              <div className="mt-3">
                <h4>Türkiye’de Cargill</h4>

                <p>
                  Cargill, 1960 yılında yerli ortaklık sözleşmesi ile Türkiye’de
                  faaliyet göstermeye başladı. Cargill olarak ticarete ise 1986
                  yılında başlandı. Şirketin Türkiye’de İstanbul, Bursa,
                  Balıkesir, İzmit, Adana, İzmir ve Ankara olmak üzere yedi
                  farklı ilde 600’den fazla çalışanı bulunuyor. Cargill’in
                  Türkiye’deki merkez ofisi 1992 yılında açılmış olup
                  İstanbul’da bulunmaktadır. Cargill’in faaliyet gösterdiği
                  başlıca sektörler ise gıda, endüstriyel & bio-endüstriyel
                  ürünlerdir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default AboutUs;
